import { Box, Typography } from "@mui/material"
import React from "react"



const ViewTableWrapper = ({ children }: any) => (
    <Box sx={{
        border: "solid 1px #eee",
        borderRadius: "8px"
    }}>
        {children}
    </Box >
);

ViewTableWrapper.Header = (props: any) => (
    <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        padding: {xs: "10px", md: "15px 30px"}
    }}>
        <Box>
            <Typography sx={{
                fontSize: {xs: "1rem", md: "1.2rem"},
                color: "#000",
                fontWeight: 500,
            }}>{props?.title}</Typography>
        </Box>
        <Box sx={{width: {xs: "100%", sm: "auto"}}}>
            {props?.children}
        </Box>
    </Box>
);

ViewTableWrapper.Content = (props: any) => (
    <Box sx={{
        padding: {xs: "1rem 1rem", md: "1rem 1.2rem"}
    }}>
        {props?.children}
    </Box>
)

export default ViewTableWrapper